import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { cn } from "../lib/utils";

export function Markdown({ children, className }) {
  return (
    <div className={cn("text-sm leading-relaxed space-y-2", className)}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: (p) => <h3 className="font-heading font-bold text-base mt-2 mb-1" {...p} />,
          h2: (p) => <h4 className="font-heading font-bold text-sm mt-2 mb-1" {...p} />,
          h3: (p) => <h4 className="font-heading font-semibold text-sm mt-2 mb-1" {...p} />,
          h4: (p) => <h5 className="font-semibold text-sm mt-1.5" {...p} />,
          p: (p) => <p className="text-sm text-foreground" {...p} />,
          ul: (p) => <ul className="list-disc pl-5 space-y-1" {...p} />,
          ol: (p) => <ol className="list-decimal pl-5 space-y-1" {...p} />,
          li: (p) => <li className="text-sm" {...p} />,
          strong: (p) => <strong className="font-semibold text-foreground" {...p} />,
          em: (p) => <em className="italic" {...p} />,
          a: (p) => <a className="text-primary underline underline-offset-2" target="_blank" rel="noreferrer" {...p} />,
          table: (p) => <div className="overflow-x-auto"><table className="w-full text-xs border-collapse my-2" {...p} /></div>,
          th: (p) => <th className="text-left border border-border px-2 py-1 bg-muted/50 font-semibold" {...p} />,
          td: (p) => <td className="border border-border px-2 py-1 align-top" {...p} />,
          code: (p) => <code className="num text-xs bg-muted px-1 py-0.5 rounded-sm" {...p} />,
          hr: () => <hr className="border-border/60 my-2" />,
          blockquote: (p) => <blockquote className="border-l-2 border-border pl-3 text-muted-foreground" {...p} />,
        }}
      >
        {children || ""}
      </ReactMarkdown>
    </div>
  );
}
